var map = {
	"./family-lang-switch.svg": 1275,
	"./green-stars-circle-solid.svg": 1391,
	"./green-tick.svg": 1396,
	"./happy-kids-home-01-darkgreen.svg": 1420,
	"./happy-kids-home-01.svg": 1421,
	"./happy-kids-home-02-darkgreen.svg": 1422,
	"./happy-kids-home-02.svg": 1423,
	"./happy-kids-home-03-darkgreen.svg": 1424,
	"./happy-kids-home-03.svg": 1425,
	"./hero-dream.svg": 1485,
	"./hero-education.svg": 1486,
	"./hero-health.svg": 1487,
	"./icon-quote.svg": 1397,
	"./insurer-company.svg": 1488,
	"./price-roll.svg": 1489,
	"./price-tag.svg": 1349,
	"./shield.svg": 1490
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2065;